export default __webpack_public_path__ + "static/media/global-internet.026499b6.jpg";